import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import sum from 'lodash/sum';

import { Account } from '@tcs/client-portal-api/types/Account';
import AccountInfoCard from '@tcs/client-portal-common/components/molecules/AccountInfoCard';
import AccountsTable from '@tcs/client-portal-common/components/molecules/AccountsTable';
import { AccountsDistributionCard } from '@tcs/client-portal-common/components/molecules/AccountsDistributionCard';
import Spinner from '@tcs/common/components/atoms/Spinner';
import { useStyles } from './AccountsOverview.style';

interface Props {
  accounts: Account[];
  loading?: boolean;
}

const AccountsOverview = ({ accounts = [], loading }: Props) => {
  const classes = useStyles();
  const nav = useNavigate();

  const [totalValue, totalAvailableCash] = useMemo(() => {
    const value = sum(accounts.map((a) => a.totalValue));
    const cash = sum(accounts.map((a) => a.availableCash));
    return [value, cash];
  }, [accounts]);

  if (loading) {
    return <Spinner />;
  }

  const onClickAccountsTableRow = ({ accountNumber }: Account) => {
    nav(`/accounts/${accountNumber}`);
  };

  return (
    <div>
      <div className={classes.wrapper}>
        <AccountInfoCard
          title="Total Value of Accounts"
          totalValue={totalValue}
          availableCash={totalAvailableCash}
        />
        <AccountsDistributionCard accounts={accounts} />
      </div>
      <AccountsTable accounts={accounts} onRowClick={onClickAccountsTableRow} />
    </div>
  );
};

export default AccountsOverview;
